module.exports = __webpack_public_path__ + "img/IMG_1699_Black.ee4e5854.jpg";